// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20vTq","right":"styles_right__2syPX"};